import React, { Component } from 'react';
import { PropTypes } from "prop-types";
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import { isEmpty } from "lodash";
import { withRouter } from 'react-router-dom';
import { fetchEmployeeSalaries } from '../../store/actions/salariesAction'
import { fetchServices, fetchFunctions  } from '../../store/actions/employeeAction'
import { fetchSalaryCats } from '../../store/actions/salaryCatsAction'
import { fetchProjects } from '../../store/actions/projectAction'
import { fetchEmployeeTimesheets,
    updateTimesheet,
    newTimesheet } from '../../store/actions/timesheetAction'
import { 
    fetchCurrentSession,
    newUserDemand,
    updateUserDemand,
    fetchUserDemands,
    fetchArticles
} from '../../store/actions/demandAction'
import { fetchUserLoans, fetchUserLoanDemands, newLoanDemand, updateResaLoanUser, updateDemandLoanStatusUser, updateLoanDemand, deleteLoanDemand } from '../../store/actions/loanAction'
    
export default function(ComposedComponent) {

    class MustBeEmployee extends Component {
        state = {  }
        componentWillMount() {
            if (!this.props.isEmployee) {
                this.props.history.push('/')
            } 
        }
        componentWillUpdate(nextProps) {
            if(!nextProps.isEmployee) {
                this.props.history.push('/')
            }
        }
        componentDidMount = () => {
            if(this.props.isEmployee) {
                if(!this.props.STATE.sessions.fetched){
                   this.props.fetchCurrentSession()
                }
                if(isEmpty(this.props.SALARIES)){
                   this.props.fetchEmployeeSalaries()
                }
                if(isEmpty(this.props.SALARY_CATS)){
                    this.props.fetchSalaryCats()
                }
                if(isEmpty(this.props.SERVICES)){
                    this.props.fetchServices()
                }
                if(isEmpty(this.props.FUNCTIONS)){
                    this.props.fetchFunctions()
                }
                if(isEmpty(this.props.PROJECTS)){
                    this.props.fetchProjects()
                }
                if(isEmpty(this.props.TIMESHEETS)){
                    this.props.fetchEmployeeTimesheets()
                }
            }
        }
        render() {
            // console.log('====================================');
            // console.log(this.props.SALARIES);
            // console.log('====================================');
            return (
                <ComposedComponent {...this.props} />
            );
        }
    }
    
    MustBeEmployee.propTypes = {
        isEmployee : PropTypes.bool.isRequired
    }

    function mapStateToProps(state){
        return {
            isEmployee : state.auth.isEmployee,
            isSuper: state.auth.isSuperAdmin,
            employee: state.auth.employee,
            STATE: state.request,
            SALARIES: state.salaries,
            SALARY_CATS: state.salary_cats,
            SERVICES: state.services,
            FUNCTIONS: state.functions,
            PROJECTS: state.projects,
            TIMESHEETS: state.timesheets,
            CURRENT_SESSION: state.sessions.CURRENT,
            ARTICLES: state.articles,
            DEMANDS: state.demands,
            LOANS: state.loans.USER,
            LOAN_DEMANDS: state.loanDemands.USER,
            
        }
    }
    
    function mapDispatchToProps(dispatch){
        return bindActionCreators({
            fetchEmployeeSalaries,
            fetchServices,
            fetchFunctions, 
            fetchSalaryCats, 
            fetchProjects, 
            fetchEmployeeTimesheets,
            newTimesheet,
            updateTimesheet, 
            fetchCurrentSession,
            newUserDemand,
            updateUserDemand,
            fetchUserDemands,
            fetchArticles,
            fetchUserLoans,
            newLoanDemand,
            fetchUserLoanDemands,
            updateResaLoanUser,
            updateDemandLoanStatusUser,
            updateLoanDemand,
            deleteLoanDemand
        }, dispatch)
    }

    return connect(mapStateToProps, mapDispatchToProps)(withRouter(MustBeEmployee))
}